import _ from "underscore";
import $ from "jquery";
import {setElementsFromScope, show, hide, insertTextAndClean, combineElements, setUniqNamesAndIds} from "../../utilities/selectorHelpers";
import {instantiateSwitchery, setSwitchery} from '../../utilities/instantiateSwitchery';
import {createPreventDefault, isPresent, isTruthy, isBlank} from '../../utilities/general';

const elementsMap = {
  sharePrimarySwitch: '.switch-share-primary',
  prefix: '.ret-prefix',
  firstName: '.ret-first-name',
  lastName: '.ret-last-name',
  email: '.ret-email',
  addMobileBtn: '.add-mobile-number-btn',
  removeMobileBtn: '.remove-mobile-btn',
  addressSection: '.address-section',
  contactSection: '.contact-section',
  phoneSection: '.phone-section'
};

const addressElementsMap = {
  country: '.ret-country',
  address1: '.ret-address1',
  address2: '.ret-address2',
  city: '.ret-city',
  state: '.ret-state',
  zipCode: '.ret-zip-code',
  postalCodeLabel:'#postalcode-label',
  stateLabel:'#state-label',
  county: '.ret-county',
  countyMandatoryLabel: '.county-mandatory-label',
  stateSelectContainer: '.state-wrapper',
  stateTextContainer: '.state-text-wrapper',
  stateTextInput: '.ret-state-text',
  commercialAddressFlag: '.commercial-addr-flag'
 };

 const phoneElementsMap = {
  officeCountryCodeShip: '.ret-office-country-code-ship',
  officePhoneShip: '.ret-office-phone-ship',
  officeAreaCodeShip: '.ret-office-area-code-ship',
  mobileCountryCodeShip: '.ret-mobile-country-code-ship',
  mobilePhoneShip: '.ret-mobile-phone-ship',
  mobileAreaCodeShip: '.ret-mobile-area-code-ship',
  mobilePhoneSection: '.ret-mobile-number-section',
  officeExt: '.ret-office-ext',
  officeCountryCode: '.ret-office-country-code',
  officePhone: '.ret-office-phone',
  officeAreaCode: '.ret-office-area-code',
  mobileCountryCode: '.ret-mobile-country-code',
  mobilePhone: '.ret-mobile-phone',
  mobileAreaCode: '.ret-mobile-area-code',
 };

export default function ShippingTab(wizard){
  const self = this;
  const wizardElement = wizard.getWizardElement();
  const els = {};
  const primaryEls = {};
  const retailerWizard = $('#retailer-wizard');
  const validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));
  const shippingTab = wizardElement.find('.shipping-information-tab');
  const primaryTab = wizardElement.find('.primary-information-tab');
  const defaultContry = wizardElement.data('default-country');
  const usaStates = wizardElement.data('usa-states');
  const caProvinces = wizardElement.data('ca-provinces');
  const countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
  const countries = wizardElement.data('countries');
  const prefixes = wizardElement.data('prefixes');
  const retailerJsonString = wizardElement.data('retailer-obj');
  const rtlType = wizardElement.data('rtl-type');
  const elementSelector = "input, select";
  let isDataModified = false;
  let countryId;
 
  self.init = function(){
    render();
  };

  function render(){
    setElements();
    setUniqNamesAndIds(els); // jquery validator needs that all "name" attribute are unique
    loadDropDowns();
    setStates(defaultContry);
    els.country.on("change", countryChange); // due to an issue in country triggering, moving it up
    renderViewWithData();
    bindElements();
  }

  function setElements(){
    setElementsFromScope(els, addressElementsMap, shippingTab);
    setElementsFromScope(els, elementsMap, shippingTab);
    setElementsFromScope(els, phoneElementsMap, shippingTab);

    setElementsFromScope(primaryEls, addressElementsMap, primaryTab);
    setElementsFromScope(primaryEls, elementsMap, primaryTab);
    setElementsFromScope(primaryEls, phoneElementsMap, primaryTab);
  }

  function bindElements() {
    els.officeCountryCodeShip.on("change",officeCountryCodeChange);
    els.mobileCountryCodeShip.on("change",mobileCountryCodeChange);
    $(document).on("click", '.shipping-information-tab .add-mobile-number-btn', handleAddMobileBtn);
    $(document).on("click", '.shipping-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
    // for share primary address switch
    $('.shipping-information-tab .switch-share-primary').on("change", handleSharePrimarySwitch);
    // To check if some information is modified. require to replace primary info if user modified something on tab
    _.map(shippingTab.find($(elementSelector)), function(element){
      if(!$(element).is(":checkbox")){
        $(element).on("change", handleInputChange);
      }
    });
  }

  function loadDropDowns() {
    $(countries).each(function(){
      var option = $('<option />');
      option.attr('value', this.conCode).text(this.conName);
      els.country.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.officeCountryCodeShip.append(option);
    });

    $(countriesPhoneCodeList).each(function(){
      var option = $('<option />');
      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
      els.mobileCountryCodeShip.append(option);
    });

    $(prefixes).each(function(){
      var option = $('<option />');
      option.attr('value', this.cdmValue).text(this.cdmMeaning);
      els.prefix.append(option);
    });
  }

  function setStates(countryVal) {
    els.state.html('');
    var option = $('<option />'); // This is the default option
    option.attr('value', "-1").text('Select State/Province/Region');
    option.attr('selected','selected');
    option.attr('disabled','disabled');
    let checkZipCode = false;
      $(countries).each(function() {
        if(this.conCode.toString() === countryVal.toString()) {
            if(this.conPostalCodeRequired.toString() === "Y"){
              checkZipCode=true;
            }
        }
      });

    if(countryVal == "US" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.show();

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.addClass("zipcodeUS");
      els.zipCode.prop('required',true);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      els.state.append(option);
      $(usaStates).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else if(countryVal == "CA" && checkZipCode) {
      show(els.stateSelectContainer);
      hide(els.stateTextContainer);
      //els.countyMandatoryLabel.hide();

      els.state.prop('required',true);
      els.stateTextInput.prop('required',false);
      els.zipCode.removeClass("zipcodeUS");
      els.zipCode.prop('required',true);
      els.state.append(option);
      els.stateLabel.text('State/Province/Region *');
      els.postalCodeLabel.text('Postal Code *');
      $(caProvinces).each(function(){
        var option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        els.state.append(option);
      });
    } else {
      if(checkZipCode){
        els.stateLabel.text('State/Province/Region');
        els.postalCodeLabel.text('Postal Code *');
        els.state.prop('required',false);
        els.stateTextInput.prop('required',false);
        els.zipCode.removeClass("zipcodeUS");
        els.zipCode.prop('required',true);
        //els.zipCode.valid();
  
        //els.countyMandatoryLabel.hide();
        hide(els.stateSelectContainer);
        show(els.stateTextContainer);
      }else{
      els.stateLabel.text('State/Province/Region');
      els.postalCodeLabel.text('Postal Code');
      els.state.prop('required',false);
      els.stateTextInput.prop('required',false);
      els.zipCode.removeClass("zipcodeUS");
      els.zipCode.prop('required',false);
      els.zipCode.valid();

      //els.countyMandatoryLabel.hide();
      hide(els.stateSelectContainer);
      show(els.stateTextContainer);

      }
      
    }
  }

  function renderViewWithData() {
    const retailer = getRetailer();
    if(_.isObject(retailer)) { // During edit, pre populate data
       setSwithcery(els.sharePrimarySwitch, retailer.rtlShipAccEqPrimary);
       if(retailer.rtlShipAccEqPrimary) { // If shipping tab shared from primary
          hideAllSections();
       } else {
          showAllSections();
       }
        let shippingAddress = getShippingAddress(retailer);
        if(_.isObject(shippingAddress)) {
          setData(shippingAddress);
        } else {
          hide(els.mobilePhoneSection); // blank form shown with no mobile section
        }
    } else { // New retailer
      hide(els.mobilePhoneSection); // Not shown on initial load while creating new
      setSwithcery(els.sharePrimarySwitch, true);
      // since be default, share primary is Yes, hide all sections
      hideAllSections();
    }
  }

  function setData(shippingAddress) {
    els.country.val(shippingAddress.cadCountry).trigger("change");
    els.address1.val(shippingAddress.cadAddress1);
    els.address2.val(shippingAddress.cadAddress2);
    els.city.val(shippingAddress.cadCity);

    if(shippingAddress.cadCountry != "US" && shippingAddress.cadCountry != "CA") { // Set state text box
      els.stateTextInput.val(shippingAddress.cadState);
    } else {
      els.state.val(shippingAddress.cadState).trigger("change");
    }

    els.zipCode.val(shippingAddress.cadZipcode);
    els.county.val(shippingAddress.cadCounty);

    els.prefix.val(shippingAddress.cadContactNamePrefix).trigger("change");
    els.firstName.val(shippingAddress.cadContactName);
    els.lastName.val(shippingAddress.cadContactLastName);
    els.email.val(shippingAddress.cadContactEmail);

    els.officeCountryCodeShip.val(shippingAddress.cadOfficePhoneCountryCode).trigger("change");
   
    if(shippingAddress.cadOfficePhoneCountryCode==='+1'){
      
      els.officePhoneShip.attr("placeholder", "___-____");
      els.officePhoneShip.addClass('ret-phone-number-jqv');
      els.officePhoneShip.removeClass('phoneNonUS');
      els.officePhoneShip.val(shippingAddress.cadOfficePhone);        
      if(els.officeAreaCodeShip){
        els.officeAreaCodeShip.removeClass('phoneNonUS');   
        els.officeAreaCodeShip.val(shippingAddress.cadOfficePhoneAreaCode); 
      }
      addmasks();  
    }else{
     
      els.officePhoneShip.addClass('phoneNonUS');
      els.officePhoneShip.removeClass('ret-phone-number-jqv');
      els.officePhoneShip.removeAttr('placeholder');
      els.officePhoneShip.inputmask({mask: ""});      
      
      //cadOfficePhoneAreaCode validation start
      els.officeAreaCodeShip.addClass('phoneNonUS');
      els.officeAreaCodeShip.removeAttr('placeholder');
      els.officeAreaCodeShip.inputmask({mask: ""});

      if(shippingAddress.cadOfficePhoneAreaCode){
        let val= shippingAddress.cadOfficePhoneAreaCode;
        const v=val.replace(/[^0-9.]/g, "");
        shippingAddress.cadOfficePhoneAreaCode=v;

        if(els.officeAreaCodeShip){
          els.officeAreaCodeShip.inputmask({mask: ""});
	        els.officeAreaCodeShip.addClass('phoneNonUS');
          els.officeAreaCodeShip.val(v);          
	      }
      }  
      if(els.officeAreaCodeShip){
          hide(els.officeAreaCodeShip);
      }
      //cadOfficePhoneAreaCode validation end

      //cadOfficePhone validation start
      if(shippingAddress.cadOfficePhone){
        let val= shippingAddress.cadOfficePhone;
        const v=val.replace(/[^0-9.]/g, "");
        shippingAddress.cadOfficePhone=v;
        els.officePhoneShip.val(v);               
      }       
      //cadOfficePhone validation end
      
     
    }
    
    els.officeExt.val(shippingAddress.cadOfficePhoneExt);

    if(!isMobileInformationPresent(shippingAddress)) {
      els.mobileCountryCodeShip.val(shippingAddress.cadMobilePhoneCountryCode).trigger("change");
   
      if(shippingAddress.cadMobilePhoneCountryCode==='+1'){

        els.mobilePhoneShip.removeClass('phoneNonUS'); 
        if(els.cadMobilePhoneAreaCode){
          els.cadMobilePhoneAreaCode.removeClass('phoneNonUS');
        } 
        els.mobilePhoneShip.addClass('ret-phone-number-jqv');
        els.mobilePhoneShip.attr("placeholder", "___-____");
        addMasksMobilePhone(); 
        els.mobilePhoneShip.val(shippingAddress.cadMobilePhone);
        
        if(shippingAddress.cadMobilePhoneAreaCode !=null){
          els.mobileAreaCodeShip.val(shippingAddress.cadMobilePhoneAreaCode);
        }else{
          hide(els.mobileAreaCodeShip);
        } 
         
      }else{

        /* Start Phone number changes */
        els.mobilePhoneShip.addClass('phoneNonUS');
        els.mobilePhoneShip.removeClass('ret-phone-number-jqv');
        els.mobilePhoneShip.removeAttr('placeholder');
        els.mobilePhoneShip.inputmask({mask: ""}); 

        
        if(shippingAddress.cadMobilePhone){
          let val= shippingAddress.cadMobilePhone;
          const v=val.replace(/[^0-9.]/g, "");
          shippingAddress.cadMobilePhone=v;
          els.mobilePhoneShip.val(v);   
        }  
        /* End Phone number changes */

        /* Start Mobile code number changes */

        if(els.cadMobilePhoneAreaCode){
          els.mobileAreaCodeShip.inputmask({mask: ""});
          els.mobileAreaCodeShip.addClass('phoneNonUS');
          els.mobileAreaCodeShip.removeAttr('placeholder');
        }

        if(shippingAddress.cadMobilePhoneAreaCode){
          let val= shippingAddress.cadMobilePhoneAreaCode;
          const v=val.replace(/[^0-9.]/g, "");
          shippingAddress.cadMobilePhoneAreaCode=v;
          els.mobileAreaCodeShip.val(v);
        }else{
          hide(els.mobileAreaCodeShip);
        }

      }
     
      
      hide(els.addMobileBtn);
    } else {
      hide(els.mobilePhoneSection);
      show(els.addMobileBtn);
    }
  }

  function setPrimaryInfoData() {
    els.country.val(primaryEls.country.val()).trigger("change");
    els.address1.val(primaryEls.address1.val());
    els.address2.val(primaryEls.address2.val());
    els.city.val(primaryEls.city.val());

    if(primaryEls.country.val() != "US" && primaryEls.country.val() != "CA") { // Set state text input
      els.stateTextInput.val(primaryEls.stateTextInput.val());
    } else {
      els.state.val(primaryEls.state.val()).trigger("change");
    }

    els.zipCode.val(primaryEls.zipCode.val());
    els.county.val(primaryEls.county.val());

    els.prefix.val(primaryEls.prefix.val()).trigger("change");
    els.firstName.val(primaryEls.firstName.val());
    els.lastName.val(primaryEls.lastName.val());
    els.email.val(primaryEls.email.val());
    els.officeCountryCodeShip.val(primaryEls.officeCountryCode.val()).trigger("change");
    els.officePhoneShip.val(primaryEls.officePhone.val());
    els.officeAreaCodeShip.val(primaryEls.officeAreaCode.val());
    els.officeExt.val(primaryEls.officeExt.val());

    if(primaryEls.mobilePhoneSection.is(":visible")) {
      show(els.mobilePhoneSection);
      els.mobileCountryCodeShip.val(primaryEls.mobileCountryCode.val()).trigger("change");
      els.mobilePhoneShip.val(primaryEls.mobilePhone.val());
      els.mobileAreaCodeShip.val(primaryEls.mobileAreaCode.val());
      hide(els.addMobileBtn);
    } else {
      hide(els.mobilePhoneSection);
      show(els.addMobileBtn);
    }
  }

  function setSwithcery(checkbox, bool) {
    instantiateSwitchery(checkbox);
    setSwitchery(checkbox, bool);
  }

  function handleAddMobileBtn() {
    show(els.mobilePhoneSection);
    hide(els.addMobileBtn);
  }

  function handleRemoveMobileBtn() {
    hide(els.mobilePhoneSection);
    show(els.addMobileBtn);
    els.mobileCountryCodeShip.val('');
    els.mobileAreaCodeShip.val('');
    els.mobilePhoneShip.val('');

    const retailer = getRetailer();
    if(_.isObject(retailer)) {
      let shippingAddress = getShippingAddress(retailer);
      shippingAddress.cadMobilePhoneCountryCode='';
      shippingAddress.cadMobilePhone='';
      shippingAddress.cadMobilePhoneAreaCode='';  
    }

  }

  function isMobileInformationPresent(shippingAddress) {
    return isBlank(shippingAddress.cadMobilePhoneCountryCode)
      && isBlank(shippingAddress.cadMobilePhone)
      && isBlank(shippingAddress.cadMobilePhoneAreaCode);
  }

  function handleSharePrimarySwitch() {
    if(isWizardOnShippingTab()) {
      if(this.checked) {
        hideAllSections();
      } else {
        showAllSections();
        if(!isEdit() && !isDataModified) {
          setPrimaryInfoData();
        }
      }
    }
  }

  function handleInputChange(e) {
    e.preventDefault();
    if(isWizardOnShippingTab() && !self.isPrimarySwitchOn()) {
      isDataModified = true;
    }
  }

  function isWizardOnShippingTab() {
    return $(wizard.getActiveTargetForm()).filter(".shipping-information-tab").length > 0;
  }

  self.isPrimarySwitchOn = function() {
    return $('.shipping-information-tab .switch-share-primary').is(":checked");;
  }

  function showAllSections() {
      show(els.addressSection);
      show(els.contactSection);
      show(els.phoneSection);
  }

  function hideAllSections() {
      hide(els.addressSection);
      hide(els.contactSection);
      hide(els.phoneSection);
  }

  function countryChange() {
    let countryVal = els.country.find('option:selected').val();
    let isValidCountry = false;
    $(countries).each(function() {
      if(this.conCode.toString() === countryVal.toString()) {
        countryId = this.conPhoneCode.toString();
        return false;
      } 
    });
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryVal.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country_not_supported_shipping").hide();        
    }else{
      $(".country_not_supported_shipping").show();
    }
    setStates(countryVal);
    if(countryVal === "US"){
      $(".ret-office-country-code-ship option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States of America +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "CA"){
      $(".ret-office-country-code-ship option").filter(function() {
        let text= $(this).text().toString();
        return text === "Canada +1";
    }).prop("selected", true).trigger("change");
    }else if(countryVal === "UM"){
      $(".ret-office-country-code-ship option").filter(function() {
        let text= $(this).text().toString();
        return text === "United States Minor Outlying Islands +1";
    }).prop("selected", true).trigger("change");
    }else{
      $(".ret-office-country-code-ship option").filter(function() {
        let text= $(this).val().toString();
        return text === countryId.toString();
    }).prop("selected", true).trigger("change");
    }
    if(countryVal === "US" || countryVal === "CA" ){
      show(els.officeAreaCodeShip);
      els.officePhoneShip.attr("placeholder", "___-____");
      els.officePhoneShip.addClass('ret-phone-number-jqv');
      els.officePhoneShip.removeClass('phoneNonUS');
      addmasks();
    }else {
      els.officeAreaCodeShip.val('');
      if(els.officeAreaCodeShip){
          hide(els.officeAreaCodeShip);
      }
      els.officePhoneShip.val('');
      els.officePhoneShip.addClass('phoneNonUS');
      els.officePhoneShip.removeClass('ret-phone-number-jqv');
      els.officePhoneShip.removeAttr('placeholder'); 
      els.officePhoneShip.inputmask({
        mask: ""
      });
      
    }
  }

  function addmasks(){
    $('.ret-office-area-code-ship').inputmask({
      mask: "(999)"
    });

    $('.ret-office-phone-ship').inputmask({
      mask: "999-9999"
    });
  }

  function addMasksMobilePhone(){
    $('.ret-mobile-area-code-ship').inputmask({
      mask: "(999)"
    });

    $('.ret-mobile-phone-ship').inputmask({
      mask: "999-9999"
    });
  }

  function mobileCountryCodeChange(){
    let mobilecode  = els.mobileCountryCodeShip.find('option:selected').val().toString();
    els.mobilePhoneShip.val('');
    if(els.mobileAreaCodeShip){
      els.mobileAreaCodeShip.val('');
    }
    if( mobilecode === '+1'){
      show(els.mobileAreaCodeShip);
      els.mobilePhoneShip.attr("placeholder", "___-____");
      els.mobilePhoneShip.addClass('ret-phone-number-jqv');
      els.mobilePhoneShip.removeClass('phoneNonUS');
      if(els.mobileAreaCodeShip){
        els.mobileAreaCodeShip.removeClass('phoneNonUS'); 
      }
      addMasksMobilePhone();
  }else{
       hide(els.mobileAreaCodeShip);
      els.mobilePhoneShip.addClass('phoneNonUS');
      els.mobilePhoneShip.removeClass('ret-phone-number-jqv');
      els.mobilePhoneShip.removeAttr('placeholder');
      els.mobilePhoneShip.inputmask({mask: ""});
    }
  }

  function officeCountryCodeChange(){
    let phoneCode = els.officeCountryCodeShip.find('option:selected').val().toString();
    els.officePhoneShip.val('');
    if(els.officeAreaCodeShip){
      els.officeAreaCodeShip.val('');
    }
    if( phoneCode === '+1'){
      show(els.officeAreaCodeShip);
      els.officePhoneShip.attr("placeholder", "___-____");
      els.officePhoneShip.addClass('ret-phone-number-jqv');
      els.officePhoneShip.removeClass('phoneNonUS');
      if(els.officeAreaCodeShip){
        els.officeAreaCodeShip.removeClass('phoneNonUS');
      }
      addmasks();
    }else{           
      hide(els.officeAreaCodeShip);
      els.officePhoneShip.addClass('phoneNonUS');
      els.officePhoneShip.removeClass('ret-phone-number-jqv');
      els.officePhoneShip.removeAttr('placeholder'); 
      els.officePhoneShip.inputmask({mask: ""});
    }
  }


  function getRetailer() {
    if(!isBlank(retailerJsonString)) {
      return retailerJsonString;
    } else {
      return null;
    }
  }

  function getShippingAddress(retailer) {
    let shippingAddress = _(retailer.retailerAddresses).find((address, k)=>{
      return address.cadAddressType == "Shipping";
    });

    return shippingAddress;
  }

  function existingRetailerHasShippingAddress() {
    return isEdit() && _.isObject(getShippingAddress(getRetailer()));
  }

  function isEdit() {
    return _.isObject(getRetailer());
  }
}



// WEBPACK FOOTER //
// ./src/pages/maintainRetailer/ShippingTab.js